import React from 'react';

import { Badge } from '@mantine/core';
import { TrackingRow } from 'types';

const CLUB_STATUS_DISPLAY: Record<string, { label: string; color: string }> = {
  completed: { label: 'Completed', color: 'green' },
  almost_done: { label: 'Almost Done', color: 'yellow' },
  in_progress: { label: 'In Progress', color: 'kiloBlue' },
};

interface IClubStatusBadgeCellProps {
  programStatus: TrackingRow['programStatus'];
}

const ClubStatusBadgeCell = ({ programStatus }: IClubStatusBadgeCellProps): JSX.Element | null => {
  const display = CLUB_STATUS_DISPLAY[programStatus];
  if (!display) return null;

  return (
    <Badge color={display.color} variant='filled' size='xs'>
      {display.label}
    </Badge>
  );
};

export default ClubStatusBadgeCell;
